export const getEditors = (mime: string) => {
  switch (mime.toLowerCase()) {
    case 'text/html':
      return ['html', 'default'];
    default:
      return ['default'];
  }
};
